import React from "react";
import CustomRadio from "Common/CustomRadio";
import PropTypes from "prop-types";

const ResponsibleParty = ({
  isSelfPay,
  onSelfPayChange,
}) => {
  const handlePaymentTypeChange = (e) => {
    const value = e.target.value;
    const newIsSelfPay = value === "selfPay";
    onSelfPayChange({
      target: {
        name: "isSelfPay",
        type: "checkbox",
        checked: newIsSelfPay,
      },
    });
  };

  return (
    <div className="mb-6">
      <h2 className="text-lg font-medium text-gray-900 mb-2">
        Responsible Party
      </h2>
      <p className="text-sm text-gray-500 mb-4">
        Select payment responsibility and insurance information
      </p>
      <CustomRadio
        name="paymentType"
        options={[
          { value: "insurance", label: "Insurance" },
          { value: "selfPay", label: "Self Pay" },
        ]}
        checked={isSelfPay ? "selfPay" : "insurance"}
        onChange={handlePaymentTypeChange}
      />
    </div>
  );
};

ResponsibleParty.propTypes = {
  isSelfPay: PropTypes.bool.isRequired,
  onSelfPayChange: PropTypes.func.isRequired,
};

export default ResponsibleParty;
